import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalHeaderWithActions } from '@evertrue/et-components';
import EmailTemplatesLibrary from './email-templates-library';
import EmailTemplatePreview from './email-template-preview';
import EmptyStateMessage from 'components/lists/empty-state-message-tv';
import useDynamicFields from 'components/emailer/hooks/use-dynamic-fields';
import { useEmailTemplatesProvider } from '../email-templates-context';
import useFormatEmailBody from 'components/emailer/hooks/use-format-email-body';
import { getLinkUrl } from 'entities/helpers/hardcodedLinks';

const EmailTemplatesModal = ({
  closeModal,
  contact,
  setFieldValue,
  openTemplateForm,
  emailBody,
  refreshInlineImageUrls,
}) => {
  const { totalTemplates, selectedTemplate } = useEmailTemplatesProvider();
  const [shouldAddSubject, setShouldAddSubject] = useState(true);
  const { parseBodyForDynamicFields } = useDynamicFields(contact);
  const { updateBodyWithTemplate } = useFormatEmailBody();

  const handleUpdateEmail = async () => {
    shouldAddSubject && setFieldValue('subject', selectedTemplate.templateSubject);
    const parsedTemplateBody = parseBodyForDynamicFields(selectedTemplate.templateBody);
    const mergedBody = updateBodyWithTemplate(emailBody, parsedTemplateBody, selectedTemplate.id);
    const updatedBody = refreshInlineImageUrls ? await refreshInlineImageUrls(mergedBody) : mergedBody;
    setFieldValue('body', updatedBody);
    const editorEl = document.getElementsByClassName('jodit-wysiwyg')[0];
    if (editorEl) {
      editorEl.innerHTML = updatedBody;
      const placeholder = editorEl.closest('.jodit-container')?.querySelector('.jodit-placeholder');
      if (placeholder) placeholder.style.display = 'none';
    }
    setFieldValue('email_template_id', selectedTemplate.id);
    closeModal();
  };

  return (
    <>
      <ModalHeaderWithActions
        submitLabel={'Insert Template'}
        title="Email Template Library"
        closeModal={closeModal}
        onSubmit={handleUpdateEmail}
        disableSubmit={totalTemplates === 0}
      />
      {totalTemplates > 0 ? (
        <div className="templates-modal-content" style={{ display: 'flex' }}>
          <EmailTemplatesLibrary openTemplateForm={openTemplateForm} />
          <EmailTemplatePreview shouldAddSubject={shouldAddSubject} setShouldAddSubject={setShouldAddSubject} />
        </div>
      ) : (
        <EmptyStateMessage
          style={{ padding: '60px' }}
          text="You don't have any Email Template"
          icon="email"
          actionLabel={'Create Template'}
          onAction={openTemplateForm}
        >
          Speed up your workflow with Email Templates. Save time and effort with pre-prepared emails.&nbsp;
          <a href={getLinkUrl('everTrue', 'emailsHelpCenterUrl')} target="_blank" rel="noopener noreferrer">
            Learn more
          </a>
        </EmptyStateMessage>
      )}
    </>
  );
};

EmailTemplatesModal.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.object,
  setFieldValue: PropTypes.func,
  openTemplateForm: PropTypes.func,
  emailBody: PropTypes.string,
  refreshInlineImageUrls: PropTypes.func,
};

export default EmailTemplatesModal;
